import { EnvironmentFooterComponent } from "./environment-footer/environment-footer.component";


export const EXPORT_COMPONENTS = [
    EnvironmentFooterComponent,
  ];
  

  